<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Key Dates</h5>
  <div class="d-flex align-items-center gap-2  ms-auto">
    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="viewHistory()" title="History">
      <fa-icon [icon]="faHistory"></fa-icon>
    </button>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
  </div>
</div>

<div class="modal-body">

  <div *ngIf="!keyDatesLoaded" class="d-flex justify-content-center py-3">
    <div class="spinner-border spinner-border-sm text-success" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <div *ngIf="keyDatesLoaded">
    <div *ngFor="let keydate of caseKeyDates" class="mb-1">

      <!-- Type 1: read only, no add/edit -->
      <app-key-date *ngIf="keydate.keyDateTypeId == 1"
        [label]="keydate.keyDateName"
        [readOnly]="readOnly"
        [(keyDate)]="keydate.keyDateValue"
        [keyDateId]="keydate.keyDateId"
        [keyDateTypeId]="keydate.keyDateTypeId"
        [canView]="true"
        [canAdd]="false"
        [canEdit]="false"
        (add)="addKeyDate($event)" (edit)="editKeyDate($event)" (delete)="deleteKeyDate($event)">
      </app-key-date>

      <!-- Standard key dates -->
      <app-key-date *ngIf="keydate.keyDateTypeId != 1 && keydate.keyDateTypeId != 2 && keydate.keyDateTypeId != 22"
        [label]="keydate.keyDateName"
        [readOnly]="readOnly"
        [(keyDate)]="keydate.keyDateValue"
        [keyDateId]="keydate.keyDateId"
        [keyDateTypeId]="keydate.keyDateTypeId"
        [enteredByUser]="keydate.enteredByUser"
        [canView]="true"
        [canAdd]="authService.isALStaff() && keydate.canEdit"
        [canEdit]="authService.isALStaff() && keydate.canEdit"
        [includeTime]="keydate.includeTime"
        (add)="addKeyDate($event)" (edit)="editKeyDate($event)" (delete)="deleteKeyDate($event)">
      </app-key-date>

      <!-- Cancelled -->
      <app-key-date *ngIf="keydate.keyDateTypeId == 2"
        [label]="keydate.keyDateName"
        [readOnly]="readOnly"
        [(keyDate)]="keydate.keyDateValue"
        [keyDateId]="keydate.keyDateId"
        [keyDateTypeId]="keydate.keyDateTypeId"
        [enteredByUser]="keydate.enteredByUser"
        [canView]="true"
        [canAdd]="authService.isALStaff() && keydate.canEdit"
        [canEdit]="false"
        (add)="cancelCase()">
      </app-key-date>

      <!-- Completion Date (type 22) -->
      <ng-container *ngIf="keydate.keyDateTypeId == 22">
        <app-key-date
          [label]="keydate.keyDateName"
          [readOnly]="readOnly"
          [(keyDate)]="keydate.keyDateValue"
          [keyDateId]="keydate.keyDateId"
          [keyDateTypeId]="keydate.keyDateTypeId"
          [enteredByUser]="keydate.enteredByUser"
          [canView]="true"
          [canAdd]="authService.isALStaff() && keydate.canEdit"
          [canEdit]="authService.isALStaff() && keydate.canEdit"
          (add)="addKeyDate($event)" (edit)="editKeyDate($event)" (delete)="deleteKeyDate($event)">
        </app-key-date>

        <div class="row align-items-center py-2">
          <div class="col-8 fw-bold">Completion Month</div>
          <div class="col-3 d-flex justify-content-end gap-2 border-bottom border-dotted align-self-stretch">
            <span class="">{{ getMonthForDate(keydate.keyDateValue) }}</span>
          </div>
          <div class="col">
          </div>
        </div>


      </ng-container>

    </div>
  </div>

</div>